export const urlParams = new URLSearchParams(window.location.search);